var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "FormulateForm",
    { ref: "policyForm", attrs: { name: "policyForm" } },
    [
      _c(
        "b-card-actions",
        {
          attrs: {
            title: _vm.$t("Dados da política"),
            "no-actions": "",
            "show-loading": _vm.saving,
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "5" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-name",
                      label: _vm.$t("Nome"),
                      name: "name",
                      type: "text",
                      validation: "required",
                    },
                    model: {
                      value: _vm.formPolicy.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "name", $$v)
                      },
                      expression: "formPolicy.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-cost-config",
                      label: _vm.$t("Configuração de custo"),
                      name: "acquirerCostConfigId",
                      type: "vue-select",
                      validation: "required",
                      placeholder: _vm.$t("Selecione"),
                      options: _vm.costConfigOptions,
                      instruction: _vm.$t(
                        "Determina o custo da adquirente usado para apurar a cobertura desta política"
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.acquirerCostConfigId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "acquirerCostConfigId", $$v)
                      },
                      expression: "formPolicy.acquirerCostConfigId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "policy-priority",
                      label: _vm.$t("Prioridade"),
                      name: "priority",
                      type: "text-number",
                      instruction: _vm.$t(
                        "Na resolução, a política de maior prioridade vence. Empate desempata pelo escopo mais específico."
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.priority,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "priority", _vm._n($$v))
                      },
                      expression: "formPolicy.priority",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "policy-stores",
                      label: _vm.$t("Lojas"),
                      name: "storeIds",
                      type: "vue-select",
                      multiple: "",
                      placeholder: _vm.$t("Todas as lojas"),
                      options: _vm.storeOptions,
                      instruction: _vm.$t(
                        "Deixe vazio para alcançar todas as lojas. Uma política pode reger várias lojas."
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.storeIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "storeIds", $$v)
                      },
                      expression: "formPolicy.storeIds",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "policy-price-tables",
                      label: _vm.$t("Tabelas de preço"),
                      name: "priceTableIds",
                      type: "vue-select",
                      multiple: "",
                      placeholder: _vm.$t("Todas as tabelas"),
                      options: _vm.getComboPriceTables,
                      instruction: _vm.$t(
                        "Deixe vazio para alcançar todas as tabelas de preço"
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.priceTableIds,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "priceTableIds", $$v)
                      },
                      expression: "formPolicy.priceTableIds",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "p",
                  { staticClass: "text-muted mb-0" },
                  [
                    _c("feather-icon", { attrs: { icon: "InfoIcon" } }),
                    _vm._v(" " + _vm._s(_vm.scopeSummary) + " "),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-actions",
        {
          attrs: {
            title: _vm.$t("Vigência e limites"),
            "no-actions": "",
            "show-loading": _vm.saving,
          },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "policy-effective-from",
                      label: _vm.$t("Vigente de"),
                      name: "effectiveFrom",
                      type: "datepicker",
                    },
                    model: {
                      value: _vm.formPolicy.effectiveFrom,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "effectiveFrom", $$v)
                      },
                      expression: "formPolicy.effectiveFrom",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "policy-effective-to",
                      label: _vm.$t("Vigente até"),
                      name: "effectiveTo",
                      type: "datepicker",
                    },
                    model: {
                      value: _vm.formPolicy.effectiveTo,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "effectiveTo", $$v)
                      },
                      expression: "formPolicy.effectiveTo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-max-installments",
                      label: _vm.$t("Máximo de parcelas"),
                      name: "maxInstallments",
                      type: "text-number",
                      validation: "required|min:1|max:24",
                    },
                    model: {
                      value: _vm.formPolicy.maxInstallments,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "maxInstallments", _vm._n($$v))
                      },
                      expression: "formPolicy.maxInstallments",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-max-without-surcharge",
                      label: _vm.$t("Máx. parcelas sem acréscimo"),
                      name: "maxInstallmentsWithoutSurcharge",
                      type: "text-number",
                      validation: "required|min:1|max:24",
                      instruction: _vm.$t(
                        "Acima desta quantidade, o acréscimo cadastrado passa a valer"
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.maxInstallmentsWithoutSurcharge,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formPolicy,
                          "maxInstallmentsWithoutSurcharge",
                          _vm._n($$v)
                        )
                      },
                      expression: "formPolicy.maxInstallmentsWithoutSurcharge",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-min-installment-value",
                      label: _vm.$t("Valor mínimo da parcela"),
                      name: "minInstallmentValue",
                      type: "text-number",
                      currency: "R$",
                      precision: 2,
                      validation: "required",
                      instruction: _vm.$t("Zero significa sem restrição"),
                    },
                    model: {
                      value: _vm.formPolicy.minInstallmentValue,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formPolicy,
                          "minInstallmentValue",
                          _vm._n($$v)
                        )
                      },
                      expression: "formPolicy.minInstallmentValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-min-sale-value",
                      label: _vm.$t("Valor mínimo da venda"),
                      name: "minSaleValue",
                      type: "text-number",
                      currency: "R$",
                      precision: 2,
                      validation: "required",
                      instruction: _vm.$t(
                        "Abaixo deste valor a venda só é oferecida à vista. Zero significa sem restrição."
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.minSaleValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "minSaleValue", _vm._n($$v))
                      },
                      expression: "formPolicy.minSaleValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-round-installment",
                      label: _vm.$t("Parcela a arredondar"),
                      name: "roundInstallment",
                      type: "vue-select",
                      validation: "required",
                      clearable: false,
                      options: _vm.roundInstallmentOptions(),
                      instruction: _vm.$t(
                        "Onde cai a diferença de centavos do rateio, para a soma fechar com o total"
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.roundInstallment,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "roundInstallment", $$v)
                      },
                      expression: "formPolicy.roundInstallment",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-default-mode",
                      label: _vm.$t("Modalidade padrão"),
                      name: "defaultMode",
                      type: "vue-select",
                      validation: "required",
                      placeholder: _vm.$t("Selecione"),
                      options: _vm.installmentModeOptions,
                    },
                    model: {
                      value: _vm.formPolicy.defaultMode,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "defaultMode", $$v)
                      },
                      expression: "formPolicy.defaultMode",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "policy-allowed-modes",
                      label: _vm.$t("Modalidades permitidas"),
                      name: "allowedModes",
                      type: "vue-select",
                      multiple: "",
                      validation: "required",
                      placeholder: _vm.$t("Selecione"),
                      options: _vm.installmentModeOptions,
                      instruction: _vm.$t(
                        "A modalidade padrão precisa estar entre as permitidas"
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.allowedModes,
                      callback: function ($$v) {
                        _vm.$set(_vm.formPolicy, "allowedModes", $$v)
                      },
                      expression: "formPolicy.allowedModes",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "6" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "policy-apply-surcharge",
                      label: _vm.$t("Repassar acréscimo ao cliente"),
                      name: "applySurchargeToCustomer",
                      type: "switch",
                      instruction: _vm.$t(
                        "Desligado, a Loja absorve o custo e os acréscimos cadastrados servem apenas como referência de cobertura"
                      ),
                    },
                    model: {
                      value: _vm.formPolicy.applySurchargeToCustomer,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.formPolicy,
                          "applySurchargeToCustomer",
                          $$v
                        )
                      },
                      expression: "formPolicy.applySurchargeToCustomer",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-actions",
        {
          attrs: {
            title: _vm.$t("Acréscimo por quantidade de parcelas"),
            "no-actions": "",
            "show-loading": _vm.saving,
          },
        },
        [
          _c("b-table", {
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              small: "",
              "empty-text": _vm.$t("Nenhum acréscimo cadastrado"),
              fields: _vm.surchargeFields,
              items: _vm.formPolicy.surcharges,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(surchargePercent)",
                fn: function (row) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm.formatPercent(row.item.surchargePercent)) +
                        " "
                    ),
                  ]
                },
              },
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: { "show-update": false, "show-delete": true },
                      on: {
                        delete: function ($event) {
                          return _vm.removeSurcharge(row.item)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "new-surcharge-installments",
                      label: _vm.$t("Parcelas"),
                      type: "text-number",
                    },
                    model: {
                      value: _vm.newSurcharge.installments,
                      callback: function ($$v) {
                        _vm.$set(_vm.newSurcharge, "installments", _vm._n($$v))
                      },
                      expression: "newSurcharge.installments",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "3" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "new-surcharge-percent",
                      label: _vm.$t("Acréscimo (%)"),
                      type: "text-number",
                      precision: 4,
                      suffix: " %",
                    },
                    model: {
                      value: _vm.newSurcharge.surchargePercent,
                      callback: function ($$v) {
                        _vm.$set(_vm.newSurcharge, "surchargePercent", $$v)
                      },
                      expression: "newSurcharge.surchargePercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                {
                  staticClass: "d-flex align-items-end pb-1",
                  attrs: { md: "3" },
                },
                [
                  _c("e-button", {
                    attrs: { text: _vm.$t("Adicionar"), variant: "primary" },
                    on: { click: _vm.addSurcharge },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.isEdition
        ? _c("installment-policy-coverage", {
            attrs: {
              "policy-id": _vm.formPolicy.id,
              "apply-surcharge": _vm.formPolicy.applySurchargeToCustomer,
            },
          })
        : _vm._e(),
      _c("e-crud-actions", {
        attrs: { busy: _vm.saving },
        on: { save: _vm.savePolicy, cancel: _vm.cancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }